import dynamic from 'next/dynamic';
import React, { FC } from 'react';

import type { Props } from './RTEContent.Lazy';

const LazyRTEContent = dynamic(() => import('./RTEContent.Lazy'), {
    ssr: false,
});

const RTEContent: FC<Props> = (props) => <LazyRTEContent {...props} />;

export { RTEContent };
